import s from "styled-components";
import { breakPoints } from "../../../index-styled";

export const Wrap = s.li`
  display: flex;
  margin: 15px;
  max-width: 100%;
  overflow-x: hidden;
  border-bottom: ${({ theme }) => theme.border.light};
  padding-bottom: 10px;
  :last-child {
    border-bottom: 0;
    padding-bottom: 0px;
  }

  @media(max-width: ${breakPoints.sm.bp}) {
    :last-child {
      padding-bottom: 64px;
    }
  }
`;
export const Text = s.p`
  margin: 0;
  font-size: 16px;
  color: var(--font-color-main);
  word-wrap: break-word;
`;
export const Buttons = s.div`
  margin-top: 7px;
  button {
    border: none;
    box-shadow: none;
    font-weight: 500;
    font-size: 13px;
    margin-left: 5px;
    :first-child {
      margin-left: 0;
    }
  }
`;
export const ResponseButton = s.button`
  color: var(--font-color-accent);
`;
export const RemoveButton = s.button`
  color: var(--color-danger);
`;
export const RightPart = s.div`
  margin-left: 5px;
`;
export const Date = s.div`
  font-size: 12px;
  margin: 3px 0;
  color: var(--font-color-accent);
`;
export const Author = s.div`
  font-weight: 700;
  color: var(--font-color-accent);
  font-size: 14px;
`;
